// Matrice des rôles : lecture/écriture des valeurs envoyées au serveur.
// Une permission à portée vaut « own » (ses dossiers) ou « all » (tous);
// les autres valent true. Une permission absente n'est pas accordée.

export const SCOPE_OPTIONS = [
  { value: 'none', label: 'Aucun' },
  { value: 'own', label: 'Ses dossiers' },
  { value: 'all', label: 'Tous' },
];

export const COLUMNS = [
  { key: 'view', label: 'Voir' },
  { key: 'create', label: 'Créer' },
  { key: 'edit', label: 'Modifier' },
  { key: 'delete', label: 'Supprimer' },
];

export const permissionValue = (permissions, key, scoped) => {
  const value = permissions?.[key];
  if (scoped) return value === true ? 'all' : value || 'none';
  return Boolean(value);
};

export const setPermission = (permissions, key, value) => {
  const next = { ...permissions };
  if (value === 'none' || value === false || value === undefined) {
    delete next[key];
  } else {
    next[key] = value;
  }
  return next;
};

export const countGranted = (permissions) => Object.values(permissions || {}).filter(Boolean).length;
